<template>
  <div
    ref="cardDiv"
    class="flex flex-col w-full min-h-0"
  >
    <DebugLabel class="absolute right-4 top-30 z-1">
      <DebugButton
        label="卡片信息"
        class="float-right mr-4"
        @click="onCardInfoShow"
      ></DebugButton>
    </DebugLabel>

    <ClozeCardFace
      v-if="props.face.card.type === CardType.CLOZE"
      :face="props.face as any"
      :quiz-stage="props.quizStage"
    />

    <EnWordCardFace
      v-else-if="props.face.card.type === CardType.EN_WORD"
      :face="props.face as any"
    />

    <MCQCardFace
      v-else-if="props.face.card.type === CardType.MCQ"
      :face="props.face as any"
    />

    <KidHanziCardFace
      v-else-if="props.face.card.type === CardType.KID_HANZI"
      :face="props.face as any"
    />
  </div>
</template>

<script lang="ts" setup>
import { CardType, QuizStage, UnitEventType, type CardFace } from '@/types/core'
import { inject, provide, ref, computed, onMounted } from 'vue'
import ClozeCardFace from './ClozeCardFace/ClozeCardFace.vue'
import EnWordCardFace from './EnWordCardFace/EnWordCardFace.vue'
import MCQCardFace from './MCQCardFace/MCQCardFace.vue'
import KidHanziCardFace from './KidHanziCardFace/KidHanziCardFace.vue'
import DebugLabel from '../DebugLabel.vue'
import CardSource from '@/pc/pages/Package/CardSource.vue'
import { useCommonStore } from '@/stores/common-store'

import type { FeedbackStar } from './common/feedback'

// 用来统计卡片学习时长
const onCardStart = inject<(cardId: number) => void>('onCardStart', () => {})
const onCardEnd = inject<(cardId: number) => void>('onCardEnd', () => {})

const store = useCommonStore()

onMounted(() => {
  onCardStart(props.face.cardId)
})

const emit = defineEmits<{
  star: [FeedbackStar]
  answerChange: [answered: boolean]
  resultChange: [correct: boolean]
  done: []
  close: []
  next: []
  event: [cardId: number | undefined, UnitEventType]
}>()

const props = withDefaults(
  defineProps<{
    face: CardFace
    quizStage?: QuizStage
  }>(),
  {
    quizStage: undefined,
  }
)

const cardDiv = ref<HTMLDivElement | null>(null)

const isLargeScreen = computed(() => {
  if (cardDiv.value != null) {
    return cardDiv.value.clientWidth > 500
  }

  return false
})

function onCardInfoShow() {
  const card = store.cardResponseCache[props.face.cardId]
  _openDialog(CardSource, {
    title: '卡片信息',
    props: {
      card,
    },
  })
}

provide('isLargeScreen', isLargeScreen)
provide('onEvent', (event: UnitEventType) =>
  emit('event', props.face.cardId, event)
)
provide('onStar', (star: FeedbackStar) => {
  emit('star', star)
  onCardEnd(props.face.cardId)
})
provide('onNext', () => emit('next'))

// quiz
provide('answerChange', (answered: boolean) => emit('answerChange', answered))
provide('resultChange', (correct: boolean) => emit('resultChange', correct))
</script>

<style scoped></style>
